import { render, staticRenderFns } from "./companyXian.vue?vue&type=template&id=b2c0a416&scoped=true"
import script from "./companyXian.vue?vue&type=script&lang=js"
export * from "./companyXian.vue?vue&type=script&lang=js"
import style0 from "./companyXian.vue?vue&type=style&index=0&id=b2c0a416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c0a416",
  null
  
)

export default component.exports